// extracted by mini-css-extract-plugin
export default {"getOutline":"CardsArea_getOutline__rxDma","CardsArea":"CardsArea_CardsArea__OGamP","centerizeArea":"CardsArea_centerizeArea__4c9xf"};